var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content scroll"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}}),_c('u',{on:{"click":function($event){return _vm.resetCookies()}}},[_vm._v("reset cookies 🍪")])])}
var staticRenderFns = []

export { render, staticRenderFns }